export { ParagraphText1, ParagraphText2, P, P1, P2 } from '@sberdevices/plasma-core';
